export const getDomainMapping = {
  EUR: {
    site: 'de',
    isUnified: true,
  },
  GBP: {
    site: 'co.uk',
    isUnified: true,
  },
  USD: {
    site: 'com',
    isUnified: true,
  },
  CAD: {
    site: 'ca',
    isUnified: true,
  },
  PLN: {
    site: 'pl',
    isUnified: true,
  },
  SEK: {
    site: 'se',
    isUnified: true,
  },
  DKK: {
    site: 'dk',
    isUnified: true,
  },
  CZK: {
    site: 'cz',
    isUnified: true,
  },
};
